import { Grid, Alert, Box, IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CAppDialog from '../../../../app/components/CAppDialog';
import investmentActionLang from '../../../investor/langs/investmentActionLang';
import styleVariables from '../../../../app/styles/styleVariables';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';

const copy = (text: string): void => {
	if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
		void navigator.clipboard.writeText(text);
		return;
	}
	const textarea = document.createElement('textarea');
	textarea.value = text;
	textarea.setAttribute('readonly', '');
	textarea.style.position = 'absolute';
	textarea.style.left = '-9999px';
	document.body.appendChild(textarea);
	textarea.select();
	try {
		document.execCommand('copy');
	} catch (_err) {
		// no-op
	}
	document.body.removeChild(textarea);
};

const AdminShareLink = () => {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (open) {
			copy(window.location.href);
			setIsCopied(true);
		} else {
			setIsCopied(false);
		}
	}, [open]);

	const handleClose = () => {
		setIsCopied(false);
		setOpen(false);
	};

	return (
		<>
			{/* <CopyToClipboard
				options={{ debug: false, message: '' }}
				text={window.location.href}
				onCopy={() => setIsCopied(true)}
			> */}
			<Tooltip title={t(investmentActionLang.share_link.tag)}>
				<IconButton size="large" onClick={() => setOpen(true)} color="primary">
					<AppCustomIcon tag="share" color="primary" />
				</IconButton>
			</Tooltip>
			{/* </CopyToClipboard> */}
			<CAppDialog
				maxWidth="xs"
				open={open}
				title={t(investmentActionLang.share_link.tag)}
				onClose={() => handleClose()}
			>
				{isCopied ? (
					<Alert severity="success" sx={{ boxShadow: 'none', marginBottom: '20px' }}>
						{t(investmentActionLang.copy_to_clipboard_success.tag)}
					</Alert>
				) : (
					''
				)}
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12} sm={12}>
						{/* <CopyToClipboard
							options={{ debug: false, message: '' }}
							text={window.location.href}
							onCopy={() => setIsCopied(true)}
						> */}
						<Box
							style={{
								width: '100%',
								backgroundColor: styleVariables.primaryColor,
								borderRadius: '10px',
								color: '#FFF',
								cursor: 'pointer',
								padding: '20px',
								fontSize: '0.8rem',
								overflowWrap: 'break-word',
							}}
						>
							{window.location.href}
						</Box>
						{/* </CopyToClipboard> */}
					</Grid>
					{/* <Grid item xs={12} sm={12} sx={{ textAlign: 'center' }}>
						<CopyToClipboard
							options={{ debug: false, message: '' }}
							text={window.location.href}
							onCopy={() => setIsCopied(true)}
						>
							<Button
								startIcon={<ContentCopyIcon />}
								variant="contained"
								color="primary"
								disabled={isCopied}
								sx={{
									backgroundColor: '#FF4154',
									padding: '8px',
									fontSize: '0.7rem',
									'&:hover': { backgroundColor: '#FF4154' },
									'&:disabled': { backgroundColor: '#CCC' },
								}}
							>
								{t(investmentActionLang.copy_to_clipboard.tag)}
							</Button>
						</CopyToClipboard>
					</Grid> */}
				</Grid>
			</CAppDialog>
		</>
	);
};

export default AdminShareLink;
